var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.images),function(image){return _c('v-col',{key:image.id,attrs:{"lg":6,"md":6,"sm":12,"xl":4,"xs":12}},[_c('photo-card',{attrs:{"editable":true,"image":image,"isQc":_vm.isQc,"isSa":_vm.isSa}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }